/**
 * Created by alex on 18-2-19.
 */
var curr = `${window.location.protocol}//${window.location.host}`
const apiurl = process.env.API_ROOT
const ssourl = `${process.env.sso}${curr}/admin&ssoUrl=${curr}/admin/sso`
const hellourl = process.env.hellourl
const signurl = process.env.ssosignurl
export default {
  name: 'apiurl',
  apiurl: apiurl,
  ssourl: ssourl,
  hellourl: hellourl,
  signurl: signurl
}



// WEBPACK FOOTER //
// ./src/util.js